import SubtleBadge from '@/components/common/SubtleBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { GscHistoryStatus } from '@/app/KeywordResearch/types/gscApiTypes';

type GscStatusBadgeConfig = {
  label: string;
  bg: string;
  icon: IconProp;
};

const gscStatusConfig: Record<GscHistoryStatus, GscStatusBadgeConfig> = {
  inserted: { label: 'ثبت شده', bg: 'info', icon: 'plus' },
  queued: { label: 'در صف', bg: 'warning', icon: 'stream' },
  processing: { label: 'دریافت اطلاعات', bg: 'info', icon: 'sync-alt' },
  errored: { label: 'خطا', bg: 'danger', icon: 'exclamation-circle' },
  failed: { label: 'ناموفق', bg: 'danger', icon: 'times-circle' },
  finished: { label: 'تکمیل شده', bg: 'success', icon: 'check' },
  permission_denied: { label: 'عدم دسترسی', bg: 'danger', icon: 'ban' },
  no_data: { label: 'داده ندارد', bg: 'warning', icon: 'exclamation' },
  not_found_host_name: { label: 'دامنه یافت نشد', bg: 'warning', icon: 'globe' },
  not_found_credentials: {
    label: 'عدم دسترسی',
    bg: 'danger',
    icon: 'user-slash'
  }
};

export const getGscStatusConfig = (
  status?: GscHistoryStatus | string | null
): GscStatusBadgeConfig =>
  gscStatusConfig[status as GscHistoryStatus] ?? {
    label: status || '-',
    bg: 'secondary',
    icon: 'question'
  };

type GscStatusRendererProps = {
  status?: GscHistoryStatus | string | null;
};

function GscStatusRenderer({ status }: GscStatusRendererProps) {
  const { label, bg, icon } = getGscStatusConfig(status);

  return (
    <div className="w-100 d-flex h-100 align-items-center">
      <SubtleBadge pill bg={bg} className="d-block fs--2">
        <FontAwesomeIcon icon={icon} transform="shrink-2" className="mx-1" />
        {label}
      </SubtleBadge>
    </div>
  );
}

export default GscStatusRenderer;
